module.exports = __webpack_public_path__ + "static/media/main_slider_2.0c7dfe72.jpg";